import React from 'react';
import PropTypes from 'prop-types';
import {ProductImage} from '~/components/Product';
import cl from 'classnames';
import renderIcon from '~/utils/renderInlineSvg';
import {deleteHandleIcon} from '~/constants/InlineSvgs';
import screenSizes, {breakpoint} from '~/constants/MediaQueries';

import './index.scss';

/** @param {PropTypes.InferProps<typeof propTypes>} props - Component properties. */
function TrayItem(props) {
  const {
    productId,
    styleId,
    onDeleteClick,
    imageDefinition,
    className,
    selected,
    ...others
  } = props;
  const showDelete = onDeleteClick && selected;
  const {alt_uri, alt_large_uri, uri} = imageDefinition;
  return (
    <div {...others} className={cl('ndx-TrayItem', className)}>
      <div className="ndx-TrayItem-wrapper">
        <ProductImage
          altImagePath={
            breakpoint(screenSizes.largeAndAbove) ? alt_large_uri : alt_uri
          }
          height={42}
          imagePath={uri}
          productId={productId}
          styleId={styleId}
        />
      </div>
      {showDelete && (
        <div
          className="ndx-TrayItem-delete"
          dangerouslySetInnerHTML={renderIcon(deleteHandleIcon)}
          onClick={onDeleteClick}
        />
      )}
    </div>
  );
}

const propTypes = {
  productId: PropTypes.string.isRequired,
  styleId: PropTypes.string.isRequired,
  className: PropTypes.string,
  imageDefinition: PropTypes.shape({
    alt_large_uri: PropTypes.string,
    alt_uri: PropTypes.string,
    uri: PropTypes.string
  }),
  selected: PropTypes.bool,
  onDeleteClick: PropTypes.func
};

TrayItem.propTypes = propTypes;

TrayItem.defaultProps = {
  imageDefinition: {}
};

export default TrayItem;
